// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"3ccef7d9","74":"4ae7d55e","106":"6720a714","464":"01f73462","565":"856830d2","571":"3d4a54ef","580":"d9d57743","631":"1d86d2f8","679":"adbd8f71","713":"c6d580af","788":"4ab5ad8c","973":"78872731"}[chunkId] + ".chunk.js";
};